export default __webpack_public_path__ + "assets/models/66a121b35f59057280a4d1fef3a93312.glb";